import { CoreBaseService } from "@core/services/Base.service";

// Reference model
import { AuthModel } from "@models/AuthModel";

class AuthService extends CoreBaseService {
  constructor() {
    super(AuthModel);
  }
}

const inst = new AuthService();

export default inst;
